import { selectMultipartProgress, selectMultipartStep, useAppSelector } from '../../../store'
import type { UseFilesCardReturnType } from '../types'

export const useFilesCard = (fileId: string): UseFilesCardReturnType => {
  const { step = 'setup', statuses } = useAppSelector(state => selectMultipartStep(state, fileId))
  const progress = useAppSelector(state => selectMultipartProgress(state, fileId)) ?? 0

  return {
    step,
    statuses,
    progress,
  }
}
